import { buildContent } from "../../../components/route-marker";
import { getContext, getElement, store } from "@wordpress/interactivity";

import axios from "axios";

let loadPostsTimeout = null;

const recursivelyAppendArrayParams = ( params, data ) => {
	Object.entries( data ).forEach( ( [ key, value ] ) => {
		if ( Array.isArray( value ) ) {
			value.forEach( value => params.append( key, value.toString() ) )
		} else {
			params.append( key, value.toString() )
		}
	} );

	return params;
}

const getGoogleApi = () => {
	return new Promise( ( resolve ) => {
		if ( window.google && window.google.maps ) {
			return resolve( window.google );
		}

		const eventListener = () => {
			console.log( 'called from event listener' );
			resolve( window.google );
		}

		document.addEventListener( "store-locator-google-ready", eventListener );
	} );
}

const { state, actions } = store( "store-locator/directory", {
	actions: {
		initialiseAutocomplete: async () => {
			const { ref } = getElement();
			const _api = await getGoogleApi();

			const autocomplete = new _api.maps.places.Autocomplete(
				ref,
				{}
			);

			autocomplete.addListener( "place_changed", async function () {
				const place = await autocomplete.getPlace();

				state.filters.address = place.formatted_address;
				state.filters.latitude = place.geometry.location.lat();
				state.filters.longitude = place.geometry.location.lng();
			} );
		},

		initialiseMap: async () => {
			const { ref } = getElement();
			const _api = await getGoogleApi();

			const zoom = ref.dataset.zoom || 12;

			let mapSettings = {
				disableDefaultUI: true,
				zoom: parseInt( zoom ),
				center: { lat: -34.397, lng: 150.644 },
				mapId: "5cee211f052b2c6b"
			};

			// if ( lat && lng ) {
			// 	mapSettings.center = {
			// 		lat: parseFloat( lat ),
			// 		lng: parseFloat( lng )
			// 	};
			// }

			state.map = new _api.maps.Map( ref, mapSettings );

			state.infoWindow = new google.maps.InfoWindow( {
				content: ""
			} );

			actions.updateMarkersOnMap();
			actions.centreMapFromMarkers();
			actions.watchMapChanges();
		},

		setInfoWindowInstance: ( infoWindowInstance ) => {
			state.infoWindow = infoWindowInstance;
		},


		setRadius: () => {
			const { ref } = getElement();
			const { value } = ref;

			state.filters.radius = value;
		},

		setTaxonomyFilter: () => {
			const { taxonomy } = getContext();
			const { ref } = getElement();
			const { value, name } = ref;

			// console.log( { value, name } );

			state.filters.taxonomies[ taxonomy ] = value;
			console.log( JSON.stringify( state.filters ) );
		},

		toggleFilterOnScroll: () => {
			state.filterOnScroll = !state.filterOnScroll;
			actions.watchMapChanges();
			// console.log( state.filterOnScroll );
		},

		focusListing: () => {
			const context = getContext();
			const { id } = context.store;

			if ( state.isRouteMap ) {
				state.map.getDiv()?.scrollIntoView( {
					behavior: "smooth",
				} )

				state.filters.itinerary = id;
				console.log( 'loading new results for itinerary' );
				actions.loadNewResults( null, true );

				// console.log(listing);
				return;
			}

			console.log( { context } );

			actions.removeBoundsListener();

			if ( Object.keys( state.markers ).includes( id.toString() ) ) {
				const marker = state.markers[ id ];

				state.map.panTo( marker.getPosition() );

				google.maps.event.addListenerOnce( state.map, 'idle', function () {
					if ( state.filterOnScroll ) {
						actions.setupBoundsListener();
					}
				} );
			}
		},

		getFilterUrl: () => {
			const url = new URL( window.location.href );

			for ( let key in state.filters ) {
				const value = state.filters[ key ];

				if ( Array.isArray( value ) ) {
					value.forEach( value => url.searchParams.append( key, value.toString() ) )
				} else {
					url.searchParams.set( key, value );
				}
			}

			return url.toString();
		},

		submit: () => {
			actions.loadNewResults();

			if ( state.filters.latitude && state.filters.longitude ) {
				state.map.panTo( {
					lat: state.filters.latitude,
					lng: state.filters.longitude,
				} )
			}
		},

		loadNewResults: ( e = null, center = false ) => {
			if ( e ) {
				e.preventDefault();
			}

			// history.replaceState(null, '', actions.getFilterUrl());
			actions.removeBoundsListener();

			axios.get( '/wp-json/store-locator/v1/search', {
					params: state.filters,
				} )
				.then( async ( response ) => {
					// response.data
					state.stores = response.data;

					if ( !state.filters.itinerary ) {
						state.travelItineraries = state.stores;
					}

					actions.updateMarkersOnMap();

					if ( state.filterOnScroll ) {
						google.maps.event.addListenerOnce( state.map, 'idle', function () {
							actions.setupBoundsListener();
						} );
					}
				} )
				.catch( error => {
					console.error( error );

					state.markers = [];
					actions.updateMarkersOnMap();

					if ( state.filterOnScroll ) {
						google.maps.event.addListenerOnce( state.map, 'idle', function () {
							actions.setupBoundsListener();
						} );
					}
				} );
		},

		setupBoundsListener: () => {
			if ( state.boundsListener ) {
				// already listening
				return;
			}

			state.boundsListener = state.map.addListener( "bounds_changed", () => {
				if ( loadPostsTimeout ) {
					clearTimeout( loadPostsTimeout );
				}

				loadPostsTimeout = setTimeout( () => {
					const center = state.map.getCenter();

					state.filters.latitude = center.lat();
					state.filters.longitude = center.lng();

					// Load new stores
					actions.loadNewResults();
				}, 600 );
				// console.log( 'bounds changed' );
			} );
		},

		removeBoundsListener: () => {
			if ( !state.boundsListener ) {
				return;
			}

			google.maps.event.removeListener( state.boundsListener );
			state.boundsListener = null;
		},

		watchMapChanges: () => {
			if ( state.filterOnScroll ) {
				actions.setupBoundsListener();
			} else if ( state.boundsListener ) {
				actions.removeBoundsListener();
			}
		},

		centreMapFromMarkers: () => {
			const bounds = new google.maps.LatLngBounds();

			// console.log({
			// 	bounds, markers: state.markers
			// });

			actions.removeBoundsListener();

			for ( let marker of Object.values( state.markers ) ) {
				// console.log(marker);
				bounds.extend( marker.position );
			}

			if ( Object.values( state.markers ).length === 1 ) {
				state.map.panTo( bounds.getCenter() );
			} else {
				state.map.fitBounds( bounds );
			}


			// if ( state.filterOnScroll ) {
			// 	google.maps.event.addListenerOnce( state.map, 'idle', function () {
			// 		actions.setupBoundsListener();
			// 	} );
			// }
		},

		viewAllItineraries: () => {
			state.filters.itinerary = null;

			for ( let line of state.lines ) {
				line.setMap( null );
			}

			state.lines = []; // reset

			actions.loadNewResults();
		},

		updateMarkersOnMap: async () => {
			const { map, markers, stores } = state;
			const _api = await getGoogleApi();

			state.lines = [];

			if ( !Array.isArray( state.lines ) ) {
				state.lines = [];
			}

			if ( map ) {
				// Clear existing markers if needed
				if ( state.markers ) {
					Object.values( state.markers ).forEach( marker => marker.setMap( null ) );
				}

				// reset
				state.markers = {};

				console.log( { updatingMarkers: JSON.parse( JSON.stringify( state.stores ) ) } );

				const routeCoordinates = [];

				const lineSymbol = {
					path: "M 0,-1 0,1",
					strokeOpacity: 1,
					scale: 6,
				};

				const addPolylineSegment = ( start, end, map ) => {
					const segmentPath = new google.maps.Polyline( {
						path: [ start, end ],
						geodesic: true,
						strokeColor: '#A6228D',
						strokeOpacity: 0,
						strokeWeight: 8,
						icons: [
							{
								icon: lineSymbol,
								offset: "-10px",
								repeat: "30px",
							},
						]
					} );

					segmentPath.setMap( map );

					return segmentPath;
				};

				for ( let listingIndex in stores ) {
					const index = parseInt( listingIndex );
					const listing = stores[ listingIndex ];
					const _id = listing.id || listingIndex;

					console.log( listing );

					if ( listing.lat === null || listing.lng === null ) {
						continue;
					}

					let markerLabel = "";

					if ( index === 0 ) {
						markerLabel = "START";
					} else if ( index === ( stores.length - 1 ) ) {
						markerLabel = "FINISH";
					}

					const markerElement = buildContent( index + 1, markerLabel, ( state.filters.itinerary ? "travel-intinerary-map" : null ) );

					if ( index === 0 || index === ( stores.length - 1 ) ) {
						markerElement.classList.add( 'route-marker--endpoint' );
					}

					state.markers[ _id ] = new _api.maps.marker.AdvancedMarkerElement( {
						gmpClickable: true,
						content: markerElement,
						position: {
							lat: parseFloat( listing.lat ),
							lng: parseFloat( listing.lng )
						},
						map,
					} );

					const position = {
						lat: parseFloat( listing.lat ),
						lng: parseFloat( listing.lng )
					};

					routeCoordinates.push( position );

					// If there are at least two points, draw a line between the last two points
					if ( state.filters.itinerary && routeCoordinates.length > 1 ) {
						state.lines.push(
							addPolylineSegment( routeCoordinates[ routeCoordinates.length - 2 ], routeCoordinates[ routeCoordinates.length - 1 ], map )
						);
					} else {
						for ( let line of state.lines ) {
							line.setMap( null );
						}

						state.lines = []; // reset
					}

					state.markers[ _id ].addListener( 'click', ( { domEvent, latLng } ) => {
						if ( state.filters.itinerary ) {
							return;
						}

						if ( state.isRouteMap ) {
							state.filters.itinerary = listing.id;
							console.log( 'loading new results for itinerary' );
							actions.loadNewResults( null, true );

							// console.log(listing);
							return;
						} else {
							state.infoWindow.open( map, state.markers[ listing.id ] );

							axios.get( '/wp-json/store-locator/v1/listing', {
								params: { id: listing.id },
							} ).then( response => {
								// console.log(response.data);
								state.infoWindow.setContent( response.data );
							} );
						}
					} );
				}

				if ( Object.values( state.markers ).length > 0 ) {
					console.log( 'should be centering' );
					console.log( { markers: state.markers } );
					actions.centreMapFromMarkers();
				}
			}
		},
	},

	callbacks: {
		onMarkersChange: () => {
			actions.updateMarkersOnMap();
		},

		getListingImage: () => {
			const context = getContext();

			const image = context.store.image;

			if ( image ) {
				return image;
			}

			return context.fallbackImageUrl;
		},
	},
} );
